import { render, staticRenderFns } from "./NotificacoesCobranca.vue?vue&type=template&id=c2136962&"
import script from "./NotificacoesCobranca.vue?vue&type=script&lang=js&"
export * from "./NotificacoesCobranca.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
